import * as type from '../actions/types';
import { RegexDiscountType } from '../constants';

const initialState = {
  bookingsData: [],
  compareBookingsData: [],
  pastYearBookingsData: [],
  impressions: {
    impressions: {},
    compareImpressions: {},
    pastYearImpressions: {},
  },
  popularMenuItems: {
    menuItems: [],
    compareMenuItems: [],
  },
  historicalOffers: [],
  detailedInsight: {},
  fetchingDetailedInsight: true,
  detailedInsightDateRange: null,
  fetching: true,
  error: false,
  errorMessage: '',
  success: false,
  shouldFetch: true,
};

const removeStunts = (data) => {
  const withoutStunts = data.filter((reso) => {
    // NOTE: include whitelabel orders (they don't have discounts)
    if (reso.discount === null) {
      return true;
    }

    const hasStunt = RegexDiscountType.test(reso.discount);
    return hasStunt;
  });
  return withoutStunts;
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_ANALYTIC_BOOKINGS_PENDING:
      return {
        ...state,
        fetching: true,
        error: false,
        errorMessage: '',
      };
    case type.FETCH_ANALYTIC_BOOKINGS_SUCCESS: {
      const { bookings, compareBookings } = action.payload;

      const updatedBookings = removeStunts(bookings);
      const updatedCompareBookings = removeStunts(compareBookings);

      return {
        ...state,
        bookingsData: updatedBookings,
        compareBookingsData: updatedCompareBookings,
        fetching: false,
        success: true,
        shouldFetch: false,
      };
    }
    case type.FETCH_ANALYTIC_BOOKINGS_FAILURE:
      return {
        ...state,
        error: true,
        errorMessage: action.payload,
        fetching: false,
      };

    case type.FETCH_PAST_YEAR_ANALYTICS_SUCCESS: {
      const { pastYearBookings } = action.payload;

      const updatedPastYearBookings = removeStunts(pastYearBookings);

      return {
        ...state,
        pastYearBookingsData: updatedPastYearBookings,
        fetching: false,
        success: true,
        shouldFetch: false,
      };
    }

    case type.FETCH_PAST_YEAR_ANALYTICS_FAILURE:
      return {
        ...state,
        error: true,
        errorMessage: action.payload,
        fetching: false,
      };

    case type.FETCH_ANALYTIC_IMPRESSIONS_SUCCESS: {
      return {
        ...state,
        impressions: action.payload,
        fetching: false,
        success: true,
        shouldFetch: false,
      };
    }

    case type.FETCH_MENU_ITEM_ANALYTICS_SUCCESS: {
      return {
        ...state,
        popularMenuItems: action.payload,
      };
    }

    case type.FETCH_HISTORICAL_OFFERS_SUCCESS: {
      return {
        ...state,
        historicalOffers: action.payload?.data ?? [],
      };
    }

    case type.FETCH_DETAILED_INSIGHT_PENDING: {
      return {
        ...state,
        fetchingDetailedInsight: true,
        detailedInsight: {},
      };
    }

    case type.FETCH_DETAILED_INSIGHT_SUCCESS: {
      return {
        ...state,
        detailedInsightDateRange: action.payload?.variables?.monthValue, // Used for caching to prevent refetch
        fetchingDetailedInsight: false,
        detailedInsight: action.payload?.data ?? {},
      };
    }

    case type.SET_PLATFORM:
      return {
        ...state,
        bookingsData: [],
        compareBookingsData: [],
        fetching: true,
        error: false,
        errorMessage: '',
        success: false,
        shouldFetch: true,
      };

    // NOTE: update bookings if restaurant or date changes
    case type.SET_ACTIVE_RESTAURANT:
    case type.SET_SEARCH_DATES:
    case type.SET_DATE_RANGE:
      return {
        ...state,
        shouldFetch: true,
        success: false,
      };

    default:
      return state;
  }
};
